import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
  NamingConventionBuilder,
  type NamingConventionValue,
} from "@/components/shared/NamingConventionBuilder";

interface NamingConventionData {
  tags: string[];
  separator: string;
  custom_separator?: string;
  custom_tags?: string[];
}

interface NamingConventionStepProps {
  data: {
    naming_convention: NamingConventionData | null;
  };
  onChange: (data: { naming_convention: NamingConventionData }) => void;
}

const DEFAULT_VALUE: NamingConventionValue = {
  tags: [],
  separator: "_",
  custom_separator: "",
  custom_tags: [],
};

export function NamingConventionStep({ data, onChange }: NamingConventionStepProps) {
  const current = data.naming_convention;

  const value: NamingConventionValue = {
    tags: current?.tags ?? [],
    separator: current?.separator ?? "_",
    custom_separator: current?.custom_separator ?? "",
    custom_tags: current?.custom_tags ?? [],
  };

  const handleChange = (next: NamingConventionValue) => {
    onChange({ naming_convention: next });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Ad Naming Convention</CardTitle>
        <CardDescription>Build a naming pattern for your ads</CardDescription>
      </CardHeader>
      <CardContent>
        <NamingConventionBuilder value={value ?? DEFAULT_VALUE} onChange={handleChange} />
      </CardContent>
    </Card>
  );
}

